import * as React from "react"
export const ToolbarSnap = (props: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
        fill="none"
     viewBox="0 0 20 20"
    {...props}
  >
    <g >
      <path
        fill="#6C757D"
        d="M17.5 0h-1.667a2.503 2.503 0 0 0-2.5 2.5v7.32c0 1.8-1.319 3.337-3.003 3.498a3.318 3.318 0 0 1-2.572-.851A3.34 3.34 0 0 1 6.667 10V2.5c0-1.378-1.122-2.5-2.5-2.5H2.5A2.503 2.503 0 0 0 0 2.5v7.197c0 5.582 4.583 10.305 10.002 10.305a9.928 9.928 0 0 0 7.004-2.864A9.93 9.93 0 0 0 20 10.002V2.5C20 1.122 18.878 0 17.5 0ZM1.667 2.5c0-.46.374-.833.833-.833h1.667c.459 0 .833.374.833.833v1.667H1.667V2.5Zm16.666 7.502a8.271 8.271 0 0 1-2.495 5.946c-1.609 1.58-3.721 2.44-5.995 2.385-4.508-.082-8.176-3.956-8.176-8.635V5.832H5V10c0 1.406.597 2.754 1.638 3.7a5.036 5.036 0 0 0 3.851 1.277c2.53-.242 4.512-2.506 4.512-5.156V5.833h3.333v4.169Zm0-5.835H15V2.5c0-.46.373-.833.833-.833H17.5c.46 0 .833.374.833.833v1.667Z"
      />
    </g>
  </svg>
)

